var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWifiOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 68.935",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Disconnected") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-signal-wifi-off",
    "data-name": "Icon material-signal-wifi-off",
    d: "M80.54,21.267a66.365,66.365,0,0,0-40-13.746A63.453,63.453,0,0,0,26.279,9.17l35.5,35.464ZM57.86,49.514,10.54,2.16l-4.364,4.4,7.045,7.079A62.216,62.216,0,0,0,.54,21.267L40.506,71.06l.034.034.034-.034,13.4-16.7L65.385,65.768,69.75,61.4,57.86,49.514Z",
    transform: "translate(-0.54 -2.16)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiOff);
export default __webpack_public_path__ + "static/media/wifi-off.d3291268fe60e5d7269a97ce47bd8622.svg";
export { ForwardRef as ReactComponent };